<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <h4 v-if="!propOpenedInModal" class="card-title">{{ cvCardTitle }}</h4>
        <ValidationObserver ref="OrgProfile">
          <form action="#" v-if="vmOrgProfileFormData && Object.keys(vmOrgProfileFormData).length > 0">
            <div class="form-row">

              <!-- Org Name (Standard Input) -->
              <div class="col-md-12 mb-3">
                <label for="validationorg_name">{{ cvOrgNameLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="OrgName" rules="required|min:3" v-slot="{ errors }">
                  <input v-model="vmOrgProfileFormData.org_name" type="text" class="form-control" />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Available Majors (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvAvailableMajorsLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="AvailableMajors" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.available_majors"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Curriculum Design (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvCurriculumDesignLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Curriculum Design" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.curriculum_design"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Structure Size (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvStructureSizeLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Structure Size" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.structure_size"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Selectivity (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvSelectivityLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Selectivity" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.selectivity"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Cost (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvCostLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Cost" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.cost"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Weather (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvWeatherLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Weather" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.weather"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Religiosity (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvReligiosityLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Religiosity" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.religiosity"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Club Extracurriculars (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvClubExtracurricularsLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="ClubExtracurriculars" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.club_extracurriculars"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Demographics (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvDemographicsLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Demographics" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.demographics"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Campus Living (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvCampusLivingSituationLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="CampusLivingSituation" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.campus_living_situation"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Social Life (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvSocialLifePersonalityLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="SocialLifePersonality" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.social_life_personality"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Average Annual Income (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvAverageAnnualIncomeLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="AverageAnnualIncome" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.average_annual_income"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Average Graduate Debt (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvAverageGraduateDebtLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="AverageGraduateDebt" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.average_graduate_debt"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Job Opportunities (Vue Editor) -->
              <div class="col-md-12 mb-3">
                <label>{{ cvJobOpportunitiesLabel }}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="JobOpportunities" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.job_opportunities"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

            </div>
            <div class="form-group">
              <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" disabled>
                <b-spinner small label="Spinning"></b-spinner>
              </button>
              <button v-else type="button" class="btn btn-primary" @click="OrgProfileEdit()"> {{ cvSubmitBtn }} </button>
            </div>
          </form>
        </ValidationObserver>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { OrgProfiles } from "../../../../FackApi/api/OrgProfile.js"
import ApiResponse from "../../../../Utils/apiResponse.js"
import { socialvue } from "../../../../config/pluginInit.js"
import userPermission from "../../../../Utils/user_permission.js"
import { VueEditor } from "vue2-editor"

export default {
  name: "OrgProfileEdit",
  components: {
    VueEditor
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propOrgProfileObj: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      cvCardTitle: "Update Organisation Profile",
      cvSubmitBtn: "Save Changes",
      cvOrgNameLabel: "Org Name",
      cvAvailableMajorsLabel: "Available Majors",
      cvCurriculumDesignLabel: "Curriculum Design",
      cvStructureSizeLabel: "Structure Size",
      cvSelectivityLabel: "Selectivity",
      cvCostLabel: "Cost",
      cvWeatherLabel: "Weather",
      cvReligiosityLabel: "Religiosity",
      cvClubExtracurricularsLabel: "Club Extracurriculars",
      cvDemographicsLabel: "Demographics",
      cvCampusLivingSituationLabel: "Campus Living Situation",
      cvSocialLifePersonalityLabel: "Social Life Personality",
      cvAverageAnnualIncomeLabel: "Average Annual Income",
      cvAverageGraduateDebtLabel: "Average Graduate Debt",
      cvJobOpportunitiesLabel: "Job Opportunities",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Organisation Profile Info Updated",
      vmOrgProfileFormData: {},
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ "script": "super" }, { "script": "sub" }],
        [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image", "video", "formula"],
        ["clean"]
      ]
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
    this.OrgProfileView()
  },
  methods: {
    async OrgProfileView () {
      try {
        if (this.propOpenedInModal && Object.keys(this.propOrgProfileObj).length > 0) {
          this.vmOrgProfileFormData = Object.assign({}, this.propOrgProfileObj)
        }
        else {
          let OrgProfileId = this.$route.params.org_id || this.propOrgProfileObj.org_id
          let OrgProfileViewResp = await OrgProfiles.OrgProfileView(this, OrgProfileId)
          if (OrgProfileViewResp && OrgProfileViewResp.resp_status) {
            this.vmOrgProfileFormData = OrgProfileViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Error at OrgProfileView():", err.message)
      }
    },
    async OrgProfileEdit () {
      try {
        this.cvLoadingStatus = true
        let OrgProfileEditResp = await OrgProfiles.OrgProfileEdit(this, this.vmOrgProfileFormData)
        await ApiResponse.responseMessageDisplay(this, OrgProfileEditResp)

        if (OrgProfileEditResp && OrgProfileEditResp.resp_status) {
          if (this.propOpenedInModal) {
            this.$emit("emitCloseOrgProfileEditModal", this.vmOrgProfileFormData)
          }
        }
      }
      catch (err) {
        console.error("Error at OrgProfileEdit():", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
